import { render, staticRenderFns } from "./pricelist.vue?vue&type=template&id=e0a08f3a&scoped=true&"
import script from "./pricelist.vue?vue&type=script&lang=js&"
export * from "./pricelist.vue?vue&type=script&lang=js&"
import style0 from "./pricelist.vue?vue&type=style&index=0&id=e0a08f3a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0a08f3a",
  null
  
)

export default component.exports